import { useState, useRef } from "react";
import Pluralize from "pluralize";
import CustomMarkdown from "components/common/CustomMarkdown";
import AvatarUsername from "components/common/AvatarUsername";
import CurrentUserData from "components/common/CurrentUserData";
import useSharedSpacesStyles from "./SharedStyles";
import CircularImage from "components/common/CircularImage/index";
import UseSpaceState from "data/SpaceState";
import { questionAnswerCreateAPIPath, adminEditQuestionPath } from "utilities/UrlHelpers";
import AnswerDetail from "./AnswerDetail";
import UpvoteButton from "../UpvoteButton";
import ShareButton from "components/common/ShareButton";
import AnswerForm from "./AnswerForm";
import AnswersList from "./AnswersList";
import Dropdown from "./Dropdown";

const QuestionListItem = (props) => {
  let { question, spaces, hideTopAnswer, skipContainer, defaultTopAnswer, skipDropdown } = props;
  const spaceState = UseSpaceState();
  const { topAnswer, account, id, activityId, preview, url, title, description, voteCount, voted, answerCount, topVoteAvatars } = question;
  const localTopAnswer = defaultTopAnswer || topAnswer;
  const [answering, setAnswering] = useState(false);
  const [showAllAnswers, setShowAll] = useState(false);
  const answerInput = useRef();
  const classes = useSharedSpacesStyles();

  if(!spaces){ return null }
  const space = question ? spaces[question.spaceSlug] : {};
  if(!space){ return null };

  const TopAnswer = () => {
    if(!localTopAnswer || hideTopAnswer){
      return null;
    }
    return ( <AnswerDetail answer={localTopAnswer} /> );
  };

  const TopVoteAvatars = () => {
    const avatars = [];

    if(topVoteAvatars && topVoteAvatars.length > 0){
      topVoteAvatars.forEach((avatar) => {
        const avatarUrl = avatar.profilePicture;
        avatars.push(
          <a href={avatar.profileUrl} className="profile-modal-opener" data-profile-modal-username={avatar.username} key={avatarUrl} >
            <CircularImage src={avatarUrl}/>
          </a>
        )
      });
    }
    return avatars;
  };

  const handleAnswerButton = async () => {
    if(!CurrentUserData().id){
      return window.triggerSignupWall('answer-question');
    }
    if(answering && answerInput.current.value != ""){
      const resp = await Fetch(questionAnswerCreateAPIPath(id), {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          description: answerInput.current.value
        })
      });
      if(resp.ok){
        const data = await resp.json();
        if(!showAllAnswers){
          // This will pick up the new answer in the query to render answers
          setShowAll(true)
        } else {
          spaceState.answers[id].merge([data])
        }
      } else {
        alertify.error("There was a problem saving your answer, please try again or contact us");
        // don't close the form
        return;
      }
    }
    setAnswering(!answering);
  };


  return (
    <div className={`${classes.questionListItem} ${skipContainer ? 'no-container' : 'white-content-block'}`} key={id}>
      <div className="avatar-row">
        <AvatarUsername account={account} extraText="asked a question in" extraLinkText={space.title} extraLinkUrl={space.url} />
        { !skipDropdown && <Dropdown
          viewUrl={url}
          editUrl={adminEditQuestionPath(id)}
          activityId={activityId}
          followAccountId={account.id} /> }
      </div>
      <h2><a href={url}>{title}</a></h2>
      { description && <CustomMarkdown source={description} />}
      { !answering && <hr /> }
      { answering && <AnswerForm answering={answering}  onCancel={handleAnswerButton} account={account} answerInput={answerInput}  /> }
      <div className="actions-row">
        <UpvoteButton
          defaultCount={voteCount}
          defaultVoted={voted}
          voteableId={id}
          voteableType="Space::Question" />
        <div className="top-vote-avatars">
          <TopVoteAvatars />
        </div>
        <div className="right-actions">
          <ShareButton
            url={url}
            title="Check out this question on Influence.co"
            hashtags="#influenceco"/>
          { !CurrentUserData().ff_hide_posting && !CurrentUserData().messaging_blocked  && (
            <button className="btn btn-primary" onClick={handleAnswerButton}>
              <i className="fa fa-pencil"></i>&nbsp;
              { answering ? "Submit" : "Answer" }
            </button>
          )}
        </div>
      </div>
      { localTopAnswer && !hideTopAnswer && (<>
        <hr />
        <TopAnswer />
      </>)}
      { answerCount > 1 && !hideTopAnswer && !answering && !showAllAnswers && (<>
        <hr />
        <button className="btn btn-link no-padding" onClick={(e) => { e.preventDefault(); setShowAll(true); }}>
          View { answerCount - 1 } more { Pluralize("answer", (answerCount-1)) }
        </button>
      </>)}
      {
        showAllAnswers && (
          <AnswersList preview={preview} questionId={id} skipAnswerId={localTopAnswer ? localTopAnswer.id : null} />
        )
      }
    </div>
  )
}

export default QuestionListItem;
